export default {
  welcome: 'Tervetuloa',
  we_miss_you: 'Kaipaamme sinua',
  happy_friday: 'Hyvää perjantaita',
  lazy_sunday: 'Laiska sunnuntai',
  loyalty_program: 'Kanta-asiakasohjelma',
  you_might_also_like: 'Saatat pitää myös tästä',
  storefront_promo: 'Storefront-mainos',
  welcome_members_club: 'Tervetuloa jäsenklubiin',
  launch_deal: 'Lanseeraustarjous',
};
